// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context-menu {
    position: absolute;
    color: black;
    background-color: #fff;
    border: 1px solid #ccc;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);
    z-index: 1000;
    max-width: 400px;
  }
  
  .context-menu .list {
    list-style: none;
    margin: 0;
    padding: 0;
  }
  
  .context-menu .list-item {
    padding: 8px 12px;
    cursor: pointer;
    text-align:left;
  }

  .context-menu .list-item.hide {
  display: none;
  }
  
  .context-menu .list-item:hover {
    background-color: #eee;
  }
  
  hr {
    margin: 0;
  }
  
  .message {
    font-size: 80%;
  }
  `, "",{"version":3,"sources":["webpack://./src/applications/appcode/appcomponents/transcript/components/context-menu/context-menu.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,YAAY;IACZ,sBAAsB;IACtB,sBAAsB;IACtB,yCAAyC;IACzC,aAAa;IACb,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,SAAS;IACT,UAAU;EACZ;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,eAAe;EACjB;;EAEA;EACA,aAAa;EACb;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,SAAS;EACX;;EAEA;IACE,cAAc;EAChB","sourcesContent":[".context-menu {\n    position: absolute;\n    color: black;\n    background-color: #fff;\n    border: 1px solid #ccc;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.2);\n    z-index: 1000;\n    max-width: 400px;\n  }\n  \n  .context-menu .list {\n    list-style: none;\n    margin: 0;\n    padding: 0;\n  }\n  \n  .context-menu .list-item {\n    padding: 8px 12px;\n    cursor: pointer;\n    text-align:left;\n  }\n\n  .context-menu .list-item.hide {\n  display: none;\n  }\n  \n  .context-menu .list-item:hover {\n    background-color: #eee;\n  }\n  \n  hr {\n    margin: 0;\n  }\n  \n  .message {\n    font-size: 80%;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
